/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_No_InvitationsInputs */

const en_admin_statistics_no_invitations = /** @type {(inputs: Admin_Statistics_No_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No interview invitations were issued in the selected period.`)
};

const de_admin_statistics_no_invitations = /** @type {(inputs: Admin_Statistics_No_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im gewählten Zeitraum wurden keine Gesprächseinladungen ausgesprochen.`)
};

/**
* | output |
* | --- |
* | "No interview invitations were issued in the selected period." |
*
* @param {Admin_Statistics_No_InvitationsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_no_invitations = /** @type {((inputs?: Admin_Statistics_No_InvitationsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_No_InvitationsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_no_invitations(inputs)
	return en_admin_statistics_no_invitations(inputs)
});